import { Component, Input, ViewContainerRef } from '@angular/core';
import { StatsHorizontalComponent } from "../../../stats-horizontal/stats-horizontal.component";
import { Stats } from '../../../../models/stats.interface';
import { SharedModule } from "../../../../modules/shared/shared.module";
import { TableMenuOption, TableMeta } from '../../../../models/table-meta.interface';
import reservationTableConfig from './config/reservationTable.json';
import { LoadingService } from '../../../../services/loading.service';
import { MasterService } from '../../../../services/masters-service';
import { ToasterService } from '../../../../services/toaster.service';
import { TosTableService } from '../../../../services/tos-table.service';
import { PaginatedListDataResponse } from '../../../../models/paginated-list-data-response';
import { PermissionConstants } from '../../../../constants/permission-constants';
import { StatsData } from '../../../../models/stats-response.interface';
import { TableListRequest, Where } from '../../../../models/table-list-request.interface';


@Component({
  selector: 'app-reservations',
  standalone: true,
  imports: [StatsHorizontalComponent, SharedModule],
  templateUrl: './reservations.component.html',
  styleUrl: './reservations.component.scss'
})
export class ReservationsComponent {
  @Input() warehouseId: string = '';
  
  warehouseStats: Stats[] = [];
  tableMeta!: TableMeta;
  filterFields = [
      {
        displayName: 'Number',
        key: 'name',
      }
    ];
    isFilterApplied: boolean = false;
    searchTerm: any;
    focusSearch!: boolean;
    tableLoaded: boolean = false;
    tableListData: PaginatedListDataResponse = {
      totalCount: 0,
      page: 0,
      limit: 0,
      records: []
    };
    tableStats: StatsData = {
        total: 0,
        active: 0,
        inactive: 0,
    };
    sortColumn: string = "modifiedDate";
    openMenuIndex: number | null = null;
      menuOptions: TableMenuOption[] = [
    { label: 'Edit', value: 'edit' },
    { label: 'View', value: 'view' },
    { label: 'Mark as active', value: 'active'},
    { label: 'Mark as inactive', value: 'inactive' },
  ];

    totalTablePages: number = 0;
    currentTablePage: number = 1;
    sortDirection: "asc" | "desc" = "desc";
    rowsPerPage: number = 25;
    currentPage: number = 0;
    tableListRequest: TableListRequest = {
      selectFields: [
        "id",
        "name",
        "description",
        "active",
        "modifiedDate",
        "modifiedBy"
      ],
      orderBy: {
        [this.sortColumn]: this.sortDirection
      },
      limit: this.rowsPerPage,
      includeTotal :true,
      page: this.currentPage
    };
    allTableRecordsSelected: boolean = false;
    selectedItems: any[] = [];
    previousTerm: string = "";
    defaultFilters: Where = { filterConditions: [], expression: "" };
    
  



  constructor(private viewContainerRef: ViewContainerRef,
              private loadingService: LoadingService,
              private masterService: MasterService,
              private toasterService: ToasterService,
              private tosTableService: TosTableService,
    
              ) {
  }



  ngOnInit(){
    this.tableMeta = reservationTableConfig.ReservationTableConfig;
    console.log(this.warehouseId)
    this.setDefaultFilters()
      if (this.warehouseId) {
    this.loadWarehouseStats(this.warehouseId);
    console.log(this.warehouseId)
  }



    this.fetchAllRecords()


  }
  private setDefaultFilters() {
    const filterConditions = [
      {
        name: "WAREHOUSE_EQUALS",
        alias: "warehouseIdEQ",
        value: [`${this.warehouseId}`]
      }
    ];

    this.defaultFilters = {
      filterConditions: [...filterConditions],
      expression: `(warehouseIdEQ)`
    };


  }

  fetchAllRecords() {
    this.loadingService.show('inline');
    this.masterService.getReservationList(this.tableListRequest).subscribe({
      next: (res: any) => {
        this.tableListData = res.data;
        this.calculateTotalPages();
        this.tableLoaded = true;
        this.loadingService.hide()

      },
      error: (error: Error) => {
        console.error("Error occurred:", error);
        this.tableLoaded = false;
        this.loadingService.hide()
      }
    });
  }

  calculateTotalPages() {
      this.totalTablePages = Math.ceil(
        (this.tableListData?.totalCount || 50) / this.rowsPerPage
      );
  }

loadWarehouseStats(id: string) {
  this.masterService.getWarehouse(id).subscribe({
    next: (res: any) => {
      const warehouseData = res.data;
      console.log("warehouse data",warehouseData)


      this.warehouseStats = reservationTableConfig.containerColumnMeta.map((item: any) => {
        let value;

      
          value = warehouseData[item.fieldName];
        

        return {
          displayLabel: item.displayLabel,
          value: value ?? "-",
          dataType: typeof value === "number" ? "number" : "text"
        };
      });
    },
    error: (err) => {
      console.error("Failed to load warehouse data", err);
      this.toasterService.error("Unable to load warehouse stats.");
    }
  });
}



}
